"use strict";

import Vue from 'vue'
import axios from 'axios'
import {Message} from './iview.js'
import store from '@/store'
import Cookies from 'js-cookie'


console.log(process.env.VUE_APP_BASE_API)

let config = {
  baseURL: process.env.VUE_APP_BASE_API,
  timeout:4*1000,
  withCredentials: true,
}

const _axios = axios.create(config)
// axios 请求拦截器
_axios.interceptors.request.use(
  function(config){
    console.log(Cookies.get('connect.sid'))
    if(store.getters.token){
      config.headers['Authorization'] = store.getters.token;
    }
    return config
  },
  function(error){
    return Promise.reject(error)
  }
)
// axios 响应拦截器
_axios.interceptors.response.use(
  function(response){
    if(response.status == 200 || response.status == 304){
      // console.log(response.headers['Set-Cookie'])
      // console.log(response)
      // console.log(document.getcookie())
      return response.data;
    } else {
      console.log(response)
    }
  },
  function(error){
    let err_data = error.response.data;
    console.log(err_data)
    let content = ''
    if(error.response.status == 422){
      if(error.response.errcode ==7001){
        content = `${err_data.errmsg}`
      }
    } else  if(error.response.status == 500){
      content = `code:${error.response.status},msg:服务器错误`
    }
    if(content){}
    return Promise.reject(error)
  }
  
);

Plugin.install = function(Vue,options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype,{
    axios: {
      get(){
        return _axios;
      }
    },
    $axios: {
      get(){
        return _axios;
      }
    }
  })
}

Vue.use(Plugin)
export default Plugin